//Context
import React from "react"
import { actionObj, stateObj, AppContextInterface, Translation, initialStateObject } from "./const"
import {log} from "./functions"

const Context = React.createContext<AppContextInterface>(null!)
Context.displayName = "globalState"

export default Context

export function useGlobalContext(): AppContextInterface {
   return React.useContext(Context)
}